<script setup>
import { useContextStore } from "@/store/context";
import {
  useAbonnementLadBanner,
  ABO_LAD_OTHER_COOKIE_NAME
} from "@/composables/abonnement-lad";

const { layout } = useContextStore();
const { isClosedLad, closeLadBanner } = useAbonnementLadBanner(
  ABO_LAD_OTHER_COOKIE_NAME
);

const component = computed(() => {
  return defineAsyncComponent(
    lazyComponents[
      `/components/organisms/abonnement-lad/euro-de-plus/${layout}.vue`
    ]
  );
});
</script>

<template>
  <component
    :is="component"
    v-if="!isClosedLad"
    v-bind="$attrs"
    @close="closeLadBanner"
  />
</template>